import React from "react";

import { Flex, Box, Divider } from "flicket-ui";
import { List } from "~components/reservation/actions/actions.List";

export const Placeholder = () => {
  return (
    <Box
      p={{ _: 2, md: 4 }}
      pb={2}
      height={{
        _: "calc(100% - 342px)",
        sm: "calc(100% - 530px)",
        md: "100%",
      }}
      maxHeight={{
        _: "calc(100% - 342px)",
        sm: "calc(100% - 530px)",
        md: "100%",
      }}
      overflowY="auto"
      bg={{ _: "N100", md: "transparent" }}
    >
      <Flex
        mb={{ _: "6/4", md: "20px" as any }}
        height="18px"
        mt={"5px" as any}
        alignItems="center"
        bg="N200"
        borderRadius="sm"
        opacity="0.8"
      />
      <Divider />
      <Box py={1} mt={{ _: "1/2", md: 2 }}>
        <List
          zones={undefined}
          currentSort={undefined}
          handleClick={undefined}
          selected={undefined}
          pricing={undefined}
          isPlaceholder
        />
      </Box>
    </Box>
  );
};
